<nb-card size="large" style="width: 95vw; height: 95vh" accent="primary">
  <nb-card-header>
    <div class="header-content">
      <div class="close-button-wrapper">
        <button id="cars-modal-close-button-x"
          nbButton ghost size="small" class="close-button fa-pull-right" (click)="cancelCar('x')">
          <nb-icon id="cars-modal-close-button-x-icon" icon="close-outline" pack="eva"></nb-icon>
        </button>
      </div>
      <div class="title">
        <ng-container>
          <h3 id='cars-grid-modal-header' style="text-transform: capitalize" class="cars-grid-modal-header fa-pull-left">
            <span id="cars-modal-invoice" class="cart-icon p-m-1" (click)="createInvoice(data)">
              <fa-icon [icon]="faInvoice" [matTooltip]="'CAR_MARKET.GENERATE_QUOTE' | translate" ></fa-icon>
              <span style="font-size: 14px;">{{ 'CAR_MARKET.GENERATE_QUOTE' | translate }}</span>
            </span>
            <span id="cars-modal-add-to-basket" class="cart-icon p-m-1" (click)="addToBasket(data)">
              <fa-icon [icon]="faCartPlus" [matTooltip]="'CAR_MARKET.ADD_TO_MY_VEHICLES' | translate" ></fa-icon>
              <span style="font-size: 14px;">{{ 'CAR_MARKET.ADD_TO_MY_VEHICLES' | translate }}</span>
            </span>
            {{data.Manufacturer}}
          </h3>
        </ng-container>

      </div>

    </div>
  </nb-card-header>
  <nb-card-body>
    <div *ngIf="isLoading" class="loading-indicator">
      <!-- Display loading indicator or message here -->
      Loading...
    </div>
    <div *ngIf="!isLoading">
      <ng-container>
        <form action="" [formGroup]="carForm">
          <div class="form-row mb-2">
            <div class="col-md-3">
              <label for="Manufacturer">{{ 'CAR_MARKET.MANUFACTURER' | translate }}</label>
              <span class="black data" id="Manufacturer">
                {{carForm.controls['Manufacturer'].value}}
<!--                  <span class="cart-icon">-->
<!--                    <fa-icon [icon]="faCartPlus" matTooltip="הוסף לרשימת הרכבים שלי" (click)="addToBasket(data)"></fa-icon>-->
<!--                  </span>-->
              </span>
            </div>
            <div class="col-md-3">
              <label for="Model">{{ 'CAR_MARKET.MODEL' | translate }}</label>
              <span class="black data" id="Model">{{carForm.controls['Model'].value}}</span>
            </div>
            <div class="col-md-3">
              <label for="SaleCondition">{{ 'CAR_MARKET.VEHICLE_CONDITION' | translate }}</label>
              <span class="black data" id="SaleCondition">{{carForm.controls['SaleCondition'].value}}</span>
            </div>
            <div class="col-md-3">
              <label for="FuelType">{{ 'CAR_MARKET.VEHICLE_TYPE' | translate }}</label>
              <span class="black data" id="FuelType">{{carForm.controls['FuelType'].value}}</span>
            </div>
          </div>
          <div class="form-row">
<!--            <div class="col-md-6 form-group" *ngIf="!showDirham">-->
<!--              <label *ngIf="loaded && (importType === 'Commercial')" for="CarPrice">מחיר משוער לאחר שחרור מכס בישראל</label>-->
<!--              <label *ngIf="loaded && (importType === 'Taxi')" for="CarPrice">מחיר משוער למונית לאחר שחרור מכס בישראל</label>-->
<!--              <div *ngIf="!loaded">-->
<!--                <mat-spinner [diameter]="32"></mat-spinner>-->
<!--                <span class="black data">בחישוב - אנא המתן</span>-->
<!--              </div>-->
<!--&lt;!&ndash;              <span class="black data" *ngIf="loaded">{{round(calculatedPrice,0)|currency:'ILS':'symbol' : '1.0-0'}}</span>&ndash;&gt;-->
<!--              <span class="black data" *ngIf="loaded && (importType === 'Commercial')">{{round(data.C_Price,0)|currency:'ILS':'symbol' : '1.0-0'}}</span>-->
<!--              <span class="black data" *ngIf="loaded && (importType === 'Taxi')">{{round(data.C_PriceComTaxi,0)|currency:'ILS':'symbol' : '1.0-0'}}</span>-->
<!--              &lt;!&ndash;              <span class="black data">{{carForm.get('CurrencyType').value}}</span>&ndash;&gt;-->
<!--              <img *ngIf="loaded && (importType === 'Taxi')" src="/assets/images/Taxi_logo.png" alt="" width="60" height="20" style="border:2px solid black; border-radius: 4px"/>-->
<!--            </div>-->
            <div class="col-md-6 form-group">
              <label for="CarPrice">Estimated price after customs release</label>
<!--              <div *ngIf="!loaded">-->
<!--                <mat-spinner [diameter]="32"></mat-spinner>-->
<!--                <span class="black data">בחישוב - אנא המתן</span>-->
<!--              </div>-->
              <!--              <span class="black data" *ngIf="loaded">{{round(calculatedPrice,0)|currency:'ILS':'symbol' : '1.0-0'}}</span>-->
              <span class="black data" >{{round(calcCost(data)) |currency: 'EUR' : 'symbol' : '1.0-0' }}</span>
<!--              <span class="black data" *ngIf="loaded && (importType === 'Taxi')">{{round(data.C_PriceComTaxi,0)|currency:'ILS':'symbol' : '1.0-0'}}</span>-->
              <!--              <span class="black data">{{carForm.get('CurrencyType').value}}</span>-->
<!--              <img *ngIf="loaded && (importType === 'Taxi')" src="/assets/images/Taxi_logo.png" alt="" width="60" height="20" style="border:2px solid black; border-radius: 4px"/>-->
            </div>

            <div class="col-3">
              <label for="">{{ 'CAR_MARKET.MILEAGE' | translate }}</label>
              <span class="black data">{{carForm.get('Mileage').value}}</span>
            </div>
            <div class="col-md-3">
              <label for="">{{ 'CAR_MARKET.WEIGHT' | translate }}</label>
              <span class="black data">{{getWeightText()}}</span>
              <!--              <span class="black data">{{carForm.get('TotalWeight').value}}</span>-->
            </div>
          </div>
          <div class="form-row mb-2">
            <div class="col-md-6 form-group">
              <label for="">{{ 'CAR_MARKET.BASE_PRICE_ORIGIN' | translate }}</label>
              <span class="black data" *ngIf="loaded">{{data.CarPrice|currency:data.CurrencyType:'symbol' : '1.0-0'}}</span>
              <!--              <span class="black data">{{carForm.get('CurrencyType').value}}</span>-->
            </div>
          </div>


          <div class="form-row mb-2">
            <div class="col-md-6">
              <div class="form-row">
                <div class="col-md-6" *ngIf="carForm.get('SaleCondition').value !== 'New'">
                  <label for="">{{ 'CAR_MARKET.FIRST_USE' | translate }}</label>
                  <span class="black data">{{carForm.get('FirstUseDate').value}}</span>
                </div>
                <div class="col-md-6">
                  <label for="">{{ 'CAR_MARKET.MODEL_YEAR' | translate }}</label>
                  <span class="black data">{{carForm.get('ManufactureDate').value}}</span>
                </div>
              </div>
              <div class="form-row mb-2">
                <div class="col-md-6" *ngIf="carForm.get('RateType').value !== 'EXW'">
                  <label for="">InLand Delivery Price</label>
                  <span class="black data">{{carForm.get('OverlandDeliveryPrice').value}}</span>
                </div>
                <div class="col-md-6">
                  <label for="">{{ 'CAR_MARKET.FINISH_LEVEL' | translate }}</label>
                  <span class="black data">{{carForm.get('FinishLevel').value}}</span>
                </div>
              </div>

              <div class="form-row">
                <div class="col-md-6">
                  <label for="">{{ 'CAR_MARKET.COLOR' | translate }}</label>
                  <span class="black data">{{carForm.get('ExteriorColor').value}}</span>
                </div>
                <div class="col-md-6">
                  <label for="">{{ 'CAR_MARKET.UPHOLSTERY_COLOR' | translate }}</label>
                  <span class="black data">{{carForm.get('UpholsteryColor').value}}</span>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-6 form-group">
                  <label for="">{{ 'CAR_MARKET.DOORS' | translate }}</label>
                  <span class="black data">{{carForm.get('NumberOfDoors').value}}</span>
                </div>
                <div class="col-md-6 form-group">
                  <label for="">{{ 'CAR_MARKET.SEATS' | translate }}</label>
                  <span class="black data">{{carForm.get('NumberOfSeats').value}}</span>
                </div>
              </div>

              <div class="form-row mb-2">
                <div class="col-md-4">
                  <label for="">{{ 'CAR_MARKET.ORIGIN_DISCOUNT_BENEFIT' | translate }}</label>
                  <span class="black data">{{carForm.get('CertificateOfOrigin').value === 'Yes' ? ('COMMON.YES' | translate) : ('COMMON.NO' | translate)}}</span>
                </div>
                <div class="col-md-3">
                  <label for="">{{ 'CAR_MARKET.IN_ISRAEL' | translate }}</label>
                  <span class="black data">{{carForm.get('Location').value === 'Israel' ? ('COMMON.YES' | translate) : ('COMMON.NO' | translate)}}</span>
                </div>
              </div>



            </div>
            <div class="col-md-6">
              <div class="form-row mb-2">
                <div class="col-md-12 form-group">
                  <div  class="info-grafik-content">
                    <div  class="color-bar" >
                      <div class="form-row">
                        <span style="font-size: 14px; font-weight: bold;">{{ 'CAR_MARKET.AIR_POLLUTION_GRADE' | translate }}</span>
                      </div>
                      <div class="form-row">
                        <div class="col-md-6 form-group">
                          <span  class="min-text">{{ 'CAR_MARKET.MIN_POLLUTION' | translate }}</span>
                        </div>
                        <div class="col-md-6 form-group">
                          <span  class="max-text right">{{ 'CAR_MARKET.MAX_POLLUTION' | translate }}</span>
                        </div>
                      </div>
                      <div  class="row-blocks">
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 1"
                              style="background-color: rgb(35, 64, 49);">
                          1
                          <i *ngIf="carForm.get('PollutionRank').value === 1" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 2"
                              style="background-color: rgb(15, 87, 50);">
                          2
                          <i *ngIf="carForm.get('PollutionRank').value === 2" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 3"
                              style="background-color: rgb(28, 111, 59);">
                          3
                          <i *ngIf="carForm.get('PollutionRank').value === 3" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 4"
                              style="background-color: rgb(88, 162, 110);">
                          4
                          <i *ngIf="carForm.get('PollutionRank').value === 4" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 5"
                              style="background-color: rgb(23, 154, 53);">
                          5
                          <i *ngIf="carForm.get('PollutionRank').value === 5" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 6"
                              style="background-color: rgb(73, 175, 36);">
                          6
                          <i *ngIf="carForm.get('PollutionRank').value === 6" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 7"
                              style="background-color: rgb(165, 207, 45);">
                          7
                          <i *ngIf="carForm.get('PollutionRank').value === 7" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 8"
                              style="background-color: rgb(253, 239, 32);">
                          8
                          <i *ngIf="carForm.get('PollutionRank').value === 8" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 9"
                              style="background-color: rgb(254, 198, 9);">
                          9
                          <i *ngIf="carForm.get('PollutionRank').value === 9" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 10"
                              style="background-color: rgb(246, 149, 0);">
                          10
                          <i *ngIf="carForm.get('PollutionRank').value === 10" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 11"
                              style="background-color: rgb(241, 144, 76);">
                          11
                          <i *ngIf="carForm.get('PollutionRank').value === 11" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 12"
                              style="background-color: rgb(236, 91, 44);">
                          12
                          <i *ngIf="carForm.get('PollutionRank').value === 12" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div class="rank-color"
                             [class.selected]="carForm.get('PollutionRank').value === 13"
                             style="background-color: rgb(203, 36, 11);">
                          13
                          <i *ngIf="carForm.get('PollutionRank').value === 13" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 14"
                              style="background-color: rgb(203, 36, 15);">
                          14
                          <i *ngIf="carForm.get('PollutionRank').value === 14" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('PollutionRank').value === 15"
                              style="background-color: rgb(150, 31, 44);">
                          15
                          <i *ngIf="carForm.get('PollutionRank').value === 15" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row mb-2">
                <div class="col-md-8 form-group">
                  <div  class="info-grafik-content">
                    <div  class="color-bar" >
                      <div class="form-row">
                        <span style="font-size: 14px; font-weight: bold;">{{ 'CAR_MARKET.SAFETY_EQUIPMENT_LEVEL' | translate }}</span>
                      </div>
                      <div class="form-row">
                        <div class="col-md-6 form-group">
                          <span  class="min-text">רמת בטיחות נמוכה</span>
                        </div>
                        <div class="col-md-6 form-group">
                          <span  class="max-text left">רמת בטיחות גבוהה</span>
                        </div>
                      </div>
                      <div  class="row-blocks">
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 1"
                              style="background-color: rgb(186, 2, 0);">
                          1
                          <i *ngIf="carForm.get('EquipLevel').value === 1" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 2"
                              style="background-color: rgb(231, 115, 8);">
                          2
                          <i *ngIf="carForm.get('EquipLevel').value === 2" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 3"
                              style="background-color: rgb(255, 200, 0);">
                          3
                          <i *ngIf="carForm.get('EquipLevel').value === 3" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 4"
                              style="background-color: rgb(58, 184, 149);">
                          4
                          <i *ngIf="carForm.get('EquipLevel').value === 4" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 5"
                              style="background-color: rgb(56, 144, 167);">
                          5
                          <i *ngIf="carForm.get('EquipLevel').value === 5" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 6"
                              style="background-color: rgb(44, 151, 208);">
                          6
                          <i *ngIf="carForm.get('EquipLevel').value === 6" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 7"
                              style="background-color: rgb(3, 123, 200);">
                          7
                          <i *ngIf="carForm.get('EquipLevel').value === 7" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 8"
                              style="background-color: rgb(7, 126, 252);">
                          8
                          <i *ngIf="carForm.get('EquipLevel').value === 8" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>
                        <div  class="rank-color"
                              [class.selected]="carForm.get('EquipLevel').value === 9"
                              style="background-color: rgb(19, 83, 255);">
                          9
                          <i *ngIf="carForm.get('EquipLevel').value === 9" class="selected-rank-arrow" style="border-top-color: rgb(203, 36, 11);"></i>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

<!--              <div class="form-group-outline">-->
<!--                <div class="form-row mb-2">-->
<!--                  <div class="col-md-12">-->
<!--                    <label for="">תנאי מכר:</label>-->
<!--                    <span class="black data">{{carForm.get('RateType').value}}</span>-->
<!--                  </div>-->
<!--                </div>-->

<!--                &lt;!&ndash; CFR נמל אשדוד / חיפה Section &ndash;&gt;-->
<!--                <div *ngIf="carForm.get('RateType').value === 'CFR נמל אשדוד / חיפה'">-->
<!--                  <div class="form-row mb-2">-->
<!--                    <div class="col-md-12">-->
<!--                      <label for="">סוג</label>-->
<!--                      <span class="black data">{{carForm.get('CfrImportType').value}}</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="form-row">-->
<!--                    <div class="col-md-8 form-group">-->
<!--                      <label for="CfrPrice">מחיר</label>-->
<!--                      <span-->
<!--                        class="black data">{{carForm.get('CfrPrice').value|currency:carForm.get('CfrCurrencyType').value.toUpperCase():'symbol'}}</span>-->
<!--                    </div>-->
<!--                    <div class="col-md-4 form-group">-->
<!--                      &lt;!&ndash;                      <label for="">מטבע</label>&ndash;&gt;-->
<!--                      &lt;!&ndash;                      <span class="black data">{{carForm.get('CfrCurrencyType').value}}</span>&ndash;&gt;-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                &lt;!&ndash; EXW Section &ndash;&gt;-->
<!--                <div *ngIf="carForm.get('RateType').value === 'EXW'">-->
<!--                  <div class="form-row mb-1">-->
<!--                    <div class="col-md-12">-->
<!--                      <label for="">ארץ המוצא:</label>-->
<!--                      <span class="black data">{{carForm.get('Country').value}}</span>-->
<!--                    </div>-->
<!--                  </div>-->

<!--                  <div class="form-row mb-2">-->
<!--                    <div class="col-md-12">-->
<!--                      <label>עיר:</label>-->
<!--                      <span class="black data">{{carForm.get('ExwCity').value}}</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

<!--                &lt;!&ndash; FCA Section &ndash;&gt;-->
<!--                <div *ngIf="carForm.get('RateType').value === 'FCA'">-->
<!--                  <div class="form-row mb-2">-->
<!--                    <div class="col-md-12">-->
<!--                      <label for="">מדינה:</label>-->
<!--                      <span class="black data">{{carForm.get('Country').value}}</span>-->
<!--                    </div>-->
<!--                  </div>-->

<!--                  <div class="form-row mb-2">-->
<!--                    <div class="col-md-12">-->
<!--                      <label>נמל טעינה:</label>-->
<!--                      <span class="black data">{{carForm.get('FcaHarbor').value}}</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
            </div>

          </div>
          <div [ngClass]="data.Files.length > 0 ? 'form-group-outline': ''">
            <div class="form-row">
              <div class="col">
                <div class="d-flex flex-row overflow-auto">
                  <div class="p-2" *ngFor="let file of data.Files; let i = index">
                    <img [src]="file.url" class="img-fluid" class="photo" (click)="openDialog(i)">
                  </div>
                </div>
                <!-- <ngx-file-upload (filesChanged)="onFilesChanged($event)" [files]="photos"></ngx-file-upload> -->
              </div>
            </div>
          </div>

        </form>
      </ng-container>
    </div>
  </nb-card-body>
  <nb-card-footer class="sticky-footer">
    <div class="row">

      <div id="cars-modal-close-button"
        class="col text-right">
        <button nbButton matRipple (click)="cancelCar('back')" class="mr-2">{{ 'CAR_MARKET.BACK' | translate }}</button>

        <button id="cars-modal-interested-button"
          nbButton status="primary" class="mr-4 ml-4"
                [disabled]="!carForm.valid" (click)="toggleInterest()">  {{ 'CAR_MARKET.MORE_DETAILS' | translate }}
        </button>

      </div>
    </div>

  </nb-card-footer>
</nb-card>

<p-toast position="top-left"></p-toast>
